import React from 'react'
import './prescription-print.scss'
import { dateFormat } from '../../../utils/common-funtions/common'

const PrescriptionHeader = ({ info, isHeader, drDetails ,isPublic=false,medicineAndAdviceOnly=false}) => {
    return (
        <div className={`prescription-header ${!drDetails?.config?.prescriptionHeaderInPrint?"d-none":'d-block' } ${isPublic&&"public-header"}`} style={{ background: drDetails?.config?.headerBackgroundColor || "white", height: (drDetails?.config?.prescriptionHeaderHeight) ? drDetails?.config?.prescriptionHeaderHeight + "px" : "200px" }}>
            {((isHeader == true || isHeader == false) ? isHeader : true) && <div style={{display:medicineAndAdviceOnly?"none":""}} className='mt-2 pt-4 pb-2'>
                <div dangerouslySetInnerHTML={{ __html: drDetails?.config?.prescriptionHeader }} />
            </div>}
        </div>
    )
}

export default PrescriptionHeader


